module.exports = __webpack_public_path__ + "img/DAR.f82e1902.svg";